import { Basic } from './basic';
import { Uia } from './uia';
import { Dat } from './dat';
import '../connection';
export const Contract = (connection) => {
    return {
        Basic: new Basic(connection),
        Uia: new Uia(connection),
        Dat: new Dat(connection),
    };
};
//# sourceMappingURL=index.js.map